import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Switch } from "components/ui/switch";

import { DateRangePicker } from "../share-component/data-range-picker";
import { MultiSelectFormControl } from "../share-component/multi-select";

export const CustomDatasetFilters = ({
  values,
  handleChange,
  handleSubmit,
  definitions,
  time,
  setTime,
  setFieldValue,
  setQueryFilterState,
  resetForm,
  presetRange,
  setPresetRange,
  initialQueryFilterState,
  queryFilterState,
  localStorageKey,
}: any) => {
  return (
    <div className="flex flex-wrap items-end gap-4 mb-4">
      <div className="flex flex-col gap-1.5 w-full sm:flex-1">
        <Label htmlFor="query">Search</Label>
        <Input
          id="query"
          name="query"
          placeholder="Search"
          type="text"
          value={values.query}
          onChange={(e: any) => {
            handleChange(e);
            handleSubmit();
          }}
        />
      </div>
      <div className="w-full sm:w-auto sm:min-w-[200px]">
        <MultiSelectFormControl
          id={"name"}
          label={"Name"}
          options={definitions.isSuccess ? definitions.data.names : []}
          value={values.name}
          handleSubmit={handleSubmit}
        />
      </div>
      <div>
        <DateRangePicker
          time={time}
          setTime={setTime}
          setFieldValue={setFieldValue}
          handleSubmit={handleSubmit}
          presetRange={presetRange}
          setPresetRange={setPresetRange}
          disabled={values.latestRelease}
          queryFilterState={queryFilterState}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="flex items-center gap-2 h-8">
          <Switch
            checked={values.latestRelease}
            onCheckedChange={(checked: boolean) => {
              const syntheticEvent = {
                target: {
                  name: "latestRelease",
                  value: checked,
                  type: "checkbox",
                  checked,
                },
              };
              handleChange(syntheticEvent);
              handleSubmit();
            }}
            id="latestRelease"
            name="latestRelease"
          />
          <Label htmlFor="latestRelease">Latest Release</Label>
        </div>
      </div>
      <Button
        className="items-center h-7"
        variant="link"
        size="sm"
        id="clearFilters"
        name="clearFilters"
        onClick={() => {
          setTime({ startTime: 0, endTime: 0 });
          setFieldValue("release", "");
          localStorage.removeItem(localStorageKey);
          setQueryFilterState(initialQueryFilterState);
          resetForm();
          handleSubmit();
        }}
      >
        Clear
      </Button>
    </div>
  );
};
